import reverseCSS from '../css/main-inverse.css';
var themeStyle = document.createElement('style');
themeStyle.classList.add('style__ligth');
themeStyle.innerHTML = reverseCSS;
export function toLigth() {
  // console.log('dark');
  $('.dark__btm').classList.add('active');
  themeStyle.remove();
  localStorage.setItem("darkmode", 'false');
  //meta apple #fff;
  $('meta[name="theme-color"]').setAttribute("content", "#ecf4f9a4");
  soundPush('/sound/ps5/ps5-back-button.mp3');
}
export function toDark() {
  // console.log('ligth');
  $('.dark__btm').classList.remove('active');
  document.body.appendChild(themeStyle);
  localStorage.setItem("darkmode", 'true');
  // meta apple #0E1621
  $('meta[name="theme-color"]').setAttribute("content", "#17212bab");
  soundPush('/sound/ps5/ps5-back-button.mp3');
}
export function theme() {
  if (localStorage.getItem("darkmode")) {
    if (localStorage.getItem("darkmode") === 'true') {
      toDark();
    } else {
      toLigth();
    }
  } else {
    if ($('.dark__btm').getAttribute('data-auto') === "true") {
      // Check to see if Media-Queries are supported
      if (window.matchMedia) {
        // Check if the dark-mode Media-Query matches
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          // Dark
          toDark();
        } else {
          // Light
          toLigth();
        }
      } else {
        // Default (when Media-Queries are not supported)
        toLigth();
      }
    } else toLigth();
  }
  $('.dark__btm').addEventListener('click', function (e) {
    $('.dark__btm').classList.toggle('active');
    if ($('.dark__btm').classList.contains('active')) {
      toLigth();
    } else toDark();
  });
}